import React from 'react';
import { DownloadIcon } from '../Global/Icons';
import { LinkBadge } from '../Global/Transitions';




interface ProjectQuotePDFProps {
    testid: string;
    pdfBlob?: Blob | null;
    isSigned?: boolean;
    // Distinguishes the download when several quotes are on screen at once. Without it every
    // panel saves as the same "Quotation.pdf" and the files are impossible to tell apart.
    filename?: string;
}

const ProjectQuotePDF: React.FC<ProjectQuotePDFProps> = ({ testid, pdfBlob, filename = 'Quotation' }) => {
    // No API call here; use the blob from props
    const Downloadquote = () => {
        if (!pdfBlob) return;
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    };

    return (
        <LinkBadge
            className='py-3 mb-4'
            bg='secondary'
            text='white'
            border='none'
            onClick={() => { if (pdfBlob) Downloadquote(); }}
        >
            <DownloadIcon />Download PDF
        </LinkBadge>
    );
};

export default ProjectQuotePDF;